// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateShowPartialDataWarning = partialData =>

    dispatch => {

        dispatch({
            partialData,
            type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_SHOW_PARTIAL_DATA_WARNING
        });

    };



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/partial-data-warning.js